import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=4826aefe&scoped=true"
import script from "./UserProfile.ts?vue&type=script&lang=js&external"
export * from "./UserProfile.ts?vue&type=script&lang=js&external"
import style0 from "./UserProfile.scss?vue&type=style&index=0&id=4826aefe&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4826aefe",
  null
  
)

export default component.exports